import { Button } from "@tfg/ui"
import { useTranslation } from "react-i18next"

import { RunLcaOnProducts } from "@tfg/types/schemas/modules/lifeCycleAnalysis/queries/run-lca-on-products"

import { useRunLcaOnProducts } from "~/gen/api/hooks/useRunLcaOnProducts"
import { showAxiosError } from "~/utils/showAxiosError"
import { showSuccessNotification } from "~/utils/showSuccessNotification"

interface Props {
  params: RunLcaOnProducts
  onSuccess: () => void
}
export const RunLcaOnProductsButton = ({ params, onSuccess }: Props) => {
  const { t } = useTranslation("regulations")
  const { mutate, isPending: isLoading } = useRunLcaOnProducts({
    mutation: {
      onSuccess: () => {
        onSuccess()
        showSuccessNotification({
          title: t("runLcaOnProducts.notifications.success.title"),
          message: t("runLcaOnProducts.notifications.success.message"),
        })
      },
      onError: (error) => {
        showAxiosError({
          notificationTitle: t("runLcaOnProducts.notifications.error.title"),
          notificationMessage: t(
            "runLcaOnProducts.notifications.error.message"
          ),
          showNotification: true,
          error,
        })
      },
    },
  })

  return (
    <Button
      disabled={params.productIds.length === 0}
      onClick={() => {
        mutate({ data: params })
      }}
      loading={isLoading}
    >
      {t("runLcaOnProducts.cta.label", { count: params.productIds.length })}
    </Button>
  )
}
